import queryString from "query-string";

import {
  offlineActionCreator,
  offlineSubActionCreator,
  passthroughSerializer,
  urlCheckAndAddIdAndAction,
} from "actions/lib";

import {
  SALE,
  DEPLOYMENT_SALE,
  SET_CURRENT_LIVESTOCKSALE,
} from "constants/actionTypes";

import { getLivestockSaleId } from "lib/navigation";
import { serializeSaleCreate } from "lib/serializers/sale";

export const setCurrentLivestockSaleId = (
  livestockSaleId,
  shouldNavigate,
  requestLivestockSaleData = true,
) => ({
  type: SET_CURRENT_LIVESTOCKSALE.ACTION,
  livestockSaleId,
  shouldNavigate,
  requestLivestockSaleData,
});

const saleActionUrlCreator = ({
  changesSince,
  id,
  action,
  fetchAll = false,
  extraQueryParams = {},
} = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/sales/", id, action),
    query: {
      ...extraQueryParams,
      changesSince,
      all: fetchAll ? true : undefined,
    },
  });

export const SaleAction = offlineActionCreator(
  SALE,
  serializeSaleCreate, // only used for create/update
  saleActionUrlCreator,
  false,
);

SaleAction.createExternalAgentSaleFromSale = (
  saleId,
  agentRoleSlug,
  saleTitle,
  deploymentMapping,
  includeMySales,
) => {
  const payload = {
    sale_title: saleTitle,
    deployment_mapping: deploymentMapping,
    include_my_sales: includeMySales,
  };
  const options = {
    id: saleId,
    action: "create-ex-agent-sale-from-sale",
    extraQueryParams: {
      user_role: agentRoleSlug,
    },
  };

  return {
    type: SALE.CREATE_EXTERNAL_AGENT_SALE_FROM_SALE.REQUEST,
    meta: {
      offline: {
        effect: {
          url: saleActionUrlCreator(options),
          method: "POST",
          body: JSON.stringify(payload),
        },
        commit: {
          type: SALE.CREATE_EXTERNAL_AGENT_SALE_FROM_SALE.SUCCESS,
        },
        rollback: {
          type: SALE.CREATE_EXTERNAL_AGENT_SALE_FROM_SALE.FAILURE,
        },
      },
    },
  };
};

SaleAction.createSellViaExternalAgentSaleFromSale = (
  saleId,
  saleTitle,
  invoiceToOption,
) => {
  const payload = {
    sale_title: saleTitle,
    invoice_to_option: invoiceToOption,
  };
  const options = {
    id: saleId,
    action: "create-sell-via-ex-agent-sale-from-sale",
  };

  return {
    type: SALE.CREATE_SELL_VIA_EXTERNAL_AGENT_SALE_FROM_SALE.REQUEST,
    meta: {
      offline: {
        effect: {
          url: saleActionUrlCreator(options),
          method: "POST",
          body: JSON.stringify(payload),
        },
        commit: {
          type: SALE.CREATE_SELL_VIA_EXTERNAL_AGENT_SALE_FROM_SALE.SUCCESS,
        },
        rollback: {
          type: SALE.CREATE_SELL_VIA_EXTERNAL_AGENT_SALE_FROM_SALE.FAILURE,
        },
      },
    },
  };
};

SaleAction.fetchConsignableSales = offlineSubActionCreator(
  SALE.FETCH_CONSIGNABLE,
  () => `/v2/sales/consignable_sales/`,
  "GET",
);

SaleAction.checkAndDeleteCurrent = () => ({
  type: SALE.CHECK_AND_DELETE_CURRENT.REQUEST,
});

SaleAction.updateWithDeploymentSales = ({
  salePayload,
  livestockSaleId,
  deploymentSales,
}) => {
  return {
    type: SALE.UPDATE_WITH_DEPLOYMENT_SALES.REQUEST,
    livestockSaleId,
    salePayload,
    deploymentSales,
  };
};

SaleAction.createMobileTransactionalSale = values => ({
  type: SALE.CREATE_MOBILE_TRANSACTIONAL_SALE.ACTION,
  values,
});

const deploymentSaleUrlCreator = ({ id, action } = {}) =>
  urlCheckAndAddIdAndAction("/v2/sales/", id, action);

export const DeploymentSaleAction = offlineActionCreator(
  DEPLOYMENT_SALE,
  passthroughSerializer,
  deploymentSaleUrlCreator,
  true,
);

DeploymentSaleAction.bulkUpdateLotNoToPenNo = deploymentSaleId => {
  const payload = {
    deployment_sale_id: deploymentSaleId,
  };
  const options = {
    id: getLivestockSaleId(),
    action: "bulk_update_lots_to_pens",
  };
  return {
    type: DEPLOYMENT_SALE.BULK_UPDATE_LOT_NO_TO_PEN_NO.REQUEST,
    meta: {
      offline: {
        effect: {
          url: deploymentSaleUrlCreator(options),
          method: "POST",
          body: JSON.stringify(payload),
        },
        commit: {
          type: DEPLOYMENT_SALE.BULK_UPDATE_LOT_NO_TO_PEN_NO.SUCCESS,
        },
        rollback: {
          type: DEPLOYMENT_SALE.BULK_UPDATE_LOT_NO_TO_PEN_NO.FAILURE,
        },
      },
    },
  };
};
